<i18n src="../../locales/lang.json"></i18n>
<template>
  <div v-show="scheduleid>0" class="container-fluid" id="procedure-done-reject-container" style="background-color: white;">
    <div class="row mb-1" v-if="hasErrors == true">
      <div class="col text-center py-1" style="color: #FE7300; border: 1px solid #FE7300; ">
        {{$t('required_fields_missing')}}
      </div>
    </div>
    <div class="row py-1 procedure-done-reject-border">
      <div class="col-4 p-0 pl-1 text-left">
        <!--<button type="button" @click="discardChanges" class="btn btn-light px-2 py-1">{{$t('cancel')}}</button>-->
        <button v-show="false" type="button" v-if="procedure.Elements.length > 0 && (authenticationType != 'onlyemail' && authenticationType != 'anonymous')" @click="clickSave" class="btn btn-light px-2 py-1" v-bind:class="{disabled:this.$store.isChanged() == false}">{{$t('save')}}</button>
        <i class="icon-checkmark2 light" v-if="saved == true"></i>
      </div>

      <div class="col-8 p-0 pl-1 text-right">
        <i v-if="(authenticationType != 'onlyemail' && authenticationType != 'anonymous') || callFrom=='microservice'" class="icon-checkmark2 warning" v-if="savednotDone == true"></i>
        <div class="btn-group mr-1" v-if="(hasNotDoneStatuses() == true && (authenticationType != 'onlyemail' && authenticationType != 'anonymous'))
             || callFrom=='microservice'">
          <button type="button" class="btn btn-warning dropdown-toggle px-2 py-1" data-toggle="dropdown" aria-expanded="false">{{$t('not_done')}}</button>
          <div class="dropdown-menu dropdown-menu-right" style="">
            <a href="#" v-for="status in procedure.ProcedureStatuses" v-if="status.IsDone == false" class="dropdown-item" @click="setNotDoneMessage(status)">{{$t(status.Name)}}</a>
          </div>
        </div>

        <i class="icon-checkmark2 success" v-if="savedDone == true"></i>
        <button type="button" class="btn btn-success px-2 py-1 mr-1" @click="setDone" aria-expanded="false">{{$t('done')}}</button>

      </div>
    </div>
    <modal-default v-bind:disableclose="true" v-bind:title="$t('leave_note')" ref="thisModal" v-bind:onsave="setMessage" size="modal-xs mx-4 mx-md-auto">
      <div class="row">
        <div class="col-12">
          {{$t('status_change_message')}}
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <textarea v-model="message" class="form-control"></textarea>
          <label class="validation-invalid-label">{{validationmsg}}</label>
        </div>
      </div>
    </modal-default>
  </div>
</template>

<script>

  export default {
    name: "procedure-new-done-reject",
    components: {

    },
    props: {
      scheduleid: {
        required: false,
        type: String,
        default: null,
      },
    },
    data() {
      return {
        callFrom: '',
        message: '',
        savednotDone: false,
        savedDone: false,
        saved: false,
        authenticationType: '',
        hasErrors: false,
        validationmsg: ''
      }
    },

    methods: {
      setCallFrom(call) {
        this.callFrom = call;
      },
      clickSave() {
        this.saved = true;
        this.doSave(false);
      },
      async doSave(promtmessage) {

        //if (this.$store.isChanged() == false)
        //  return;
        if (this.procedure.ProcedureId != 0) {
          await this.saveExistingProcedure(promtmessage);
        }
        else {
          await this.saveNewProcedure(promtmessage);
        }
        //this.resetStatus();

      },
      setMessage() {
        if (this.message !== '' && this.message !== undefined
          && this.message !== null) {
          this.validationmsg = '';
          var m = "" + this.message;
          this.$emit('add_chat_message', m);
          this.message = "";
          this.$refs.thisModal.close();
        } else {
          this.validationmsg = this.$t('field_is_required');
        }
      },
      setDone() {
        var isValid = this.validateProcedure(this.procedure);
        if (isValid == true) {
          //this.resetStatus();
          this.savedDone = true;
          this.savednotDone = false;
          this.setStatus(2);

          // just setting this property for frontend to show on worknode view after press done button
          this.procedure.TempSuccessMessage = this.procedure.SuccessMessage;

        }
      },
      setNotDone(status) {
        //this.resetStatus();
        var isValid = this.validateProcedure(this.procedure);
        if (isValid == true) {
          this.setStatus(status, false);
          this.savednotDone = true;
          this.savedDone = false;
        }
      },
      setNotDoneMessage(status) {
        var isValid = this.validateProcedure(this.procedure);
        if (isValid == true) {
          this.setStatus(status.Id, true);
          if ((this.authenticationType != 'onlyemail' && this.authenticationType != 'anonymous')
            || this.callFrom == 'microservice') {
            if (status.PromptMessage == true)
              this.$refs.thisModal.open();
          }
          this.savednotDone = true;
          this.savedDone = false;
        }
      },
      resetStatus() {
        this.saved = false;
        this.savednotDone = false;
        this.savedDone = false;
        this.hasErrors = false;
        this.$forceUpdate();
      },
      getId() {
        return this._uid;
      },
      handleRefresh(val) {
        this.resetStatus();
      },
      revalidate(val) {
        this.validateProcedure(this.procedure)
      },

      discardChanges() {
        this.resetStatus();
        this.$store.commit('discardChanges');
        //vm.$root.$emit('procedure_editor_can_close');
        this.$root.$emit('procedure_editor_can_close');
      },
      hasNotDoneStatuses() {
        if (typeof (this.procedure.ProcedureStatuses) == "undefined")
          return false;
        var count = 0;
        for (var i = 0; i < this.procedure.ProcedureStatuses.length; i++) {
          if (this.procedure.ProcedureStatuses[i].IsDone == false)
            count++;
        }
        return count > 0;
      },
      validateProcedure(procedure) {
        var result = [];
        for (var i = 0; i < procedure.Elements.length; i++) {
          var childRes = this.validateProcedureElements(procedure.Elements[i], result)
          if (childRes.length > 0)
            result.push(childRes)
        }
        var isInValidate = this.isProcedureElementsRegxInValidate(procedure);
        this.procedure = procedure;
        //Vue.set(procedure, "Elements", procedure.Elements);
        //this.$forceUpdate();
        this.$store.commit('updateprocedure', procedure);
        if (result.length > 0) {
          this.hasErrors = true;
          return false;
        }

        if (isInValidate == true) {
          return false;
        }
        this.hasErrors = false;
        return true;
      },

      isProcedureElementsRegxInValidate(procedure) {
        for (var i = 0; i < procedure.Elements.length; i++) {
          var isInvalid = this.isElementRegxInValid(procedure.Elements[i]);
        }
        return isInvalid;
      },

      isElementRegxInValid(element) {
        if (element.IsRegxError === true) return true;
        for (var i = 0; i < element.Elements.length; i++) {
          var isInvalid = this.isElementRegxInValid(element.Elements[i]);
          return isInvalid;
        }
        return false;
      },

      validateProcedureElements(element) {
        var result = []
        for (var i = 0; i < element.Elements.length; i++) {
          var childRes = this.validateProcedureElements(element.Elements[i], result);
          if (childRes.length > 0)
            result.push(childRes)
        }
        if (element.Required == true) {
          if (!element.UserInputs || element.UserInputs == null || element.UserInputs == 0) {
            result.push("error");
            element.hasErrors = true;
          }
          else
            element.hasErrors = false;
        }
        return result;
      },

      setStatus(status) {
        var proc = JSON.parse(JSON.stringify(this.procedure));
        proc.Status = status;
        this.$store.commit('loadnewProcedure', proc);
        var showPromt = true;
        if (status == 2)
          showPromt = false;
        this.doSave(showPromt);
      },
      async saveNewProcedure(promtmessage) {

        var tmpProcedure = { name: this.procedure.ProcedureName, istask: this.procedure.IsTask };
        tmpProcedure.Settings = { Property: [] };
        tmpProcedure.Settings.Property["EnablePrivateChat"] = "True";
        var createProcedureData = JSON.stringify(tmpProcedure);
        var thisContext = this;
        var response = await this.$http.post(
          '/api/Procedure/AddProcedure',
          createProcedureData,
          {
            headers: {
              'Content-Type': 'application/json',
              "Accept": "application/json"
            }
          }
        )
          .then(response => {
            thisContext.$root.$emit('doSearch');
            var proc = thisContext.procedure;
            proc.ProcedureId = response.data.Id;
            proc.CategoryId = 1;
            this.scheduleid = response.data.ProcedureScheduleId;
            thisContext.procedure = proc;
            thisContext.saveExistingProcedure(promtmessage);
          });
      },

      async saveExistingProcedure(promtmessage) {
        //var request = this.procedure;        
        var request = {
          procedureViewModel: this.procedure,
        };
        try {
          var response = await this.$http.put(
            '/api/Procedures/v1/UpdateProcedure',
            request,
            {
              headers: {
                'Content-Type': 'application/json',
                "Accept": "application/json"
              }
            }
          )
            .then(async response => {


              var isValid = this.validateProcedure(this.procedure);
              if (isValid == true) {
                vm.$root.$emit('doSearch');
                var proc = JSON.parse(JSON.stringify(this.procedure));
                proc.ProcedureId = response.data.ProcedureId;
                proc.CategoryId = response.data.CategoryId
                proc.Description = response.data.Description;
                proc.ProcedureName = response.data.ProcedureName;
                proc.Elements = response.data.Elements;

                this.$emit('procedure_saved');
                this.$store.commit('loadnewProcedure', proc);
                if (promtmessage != true) {
                  vm.$root.$emit('procedure_editor_can_close');
                }

              }
              else {
                alert("something needs fixing")
              }

            });

        } catch (err) {
        }
      },
    },
    computed: {
      procedure: {
        get() {
          return this.$store.state.procedure;
        },
        set(value) {
          //alert("updateprocedure 9");
          this.$store.commit('saveprocedure', value)
        }
      }
    },
    mounted() {
      this.$root.$on('procedure_loaded', this.handleRefresh);
      this.$root.$on('revalidate', this.revalidate);
      this.authenticationType = this.$store.getAuthenticationType();
    },

    watch: {

    },
    created() {

    },
  };

</script>

<style scoped>
  .procedure-done-reject-border {
    border: 1px solid #ddd;
  }
</style>



// WEBPACK FOOTER //
// src/components/procedure/procedure-new-done-reject.vue